import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import { InfoBox } from "../designUi";
import { MessageIconCover } from "../UIElements/svgIcons";
import { EmployeePieChart, EmploymentBarChart } from "./employmentCharts";
import { transformStatusCount } from "../../utils/major-functions";
import { formatTextType } from "../../utils/url-id";

const EmploymentStats = ({ stats }: any) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");

  interface DataItem {
    _id: string;
    count: number;
  }

  // Function to extract _id values
  const getIds = (data: DataItem[]): string[] => {
    return data.map((item) => item._id);
  };

  // Function to extract count values
  const getCounts = (data: DataItem[]): number[] => {
    return data.map((item) => item.count);
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: isSmall ? "column" : "row",
          my: 3,
          mx: 3,
          gap: 3,
        }}
      >
        <Stack sx={{ width: isSmall ? "98%" : "40%" }}>
          <InfoBox
            title={"Total Employees"}
            value={stats?.totalEmployees ?? 0}
            icon={<MessageIconCover />}
          />
        </Stack>

        {transformStatusCount(stats?.statusCount)?.map(
          (stat: any, id: number) => (
            <Stack sx={{ width: isSmall ? "98%" : "40%" }}>
              <InfoBox
                title={`${formatTextType(stat?.name)} Employee`}
                value={stat?.count}
                icon={<MessageIconCover />}
              />
            </Stack>
          )
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: isMedium ? "column" : "row",
          gap: 10,
          justifyContent: "space-between",
          paddingX: 3,
          paddingY: 3,
        }}
      >
        <Box
          sx={{
            width: isMedium ? "100%" : "49%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
          }}
        >
          <EmploymentBarChart
            id={getIds(stats.activeEmployeesDepartment)}
            labels={getCounts(stats?.activeEmployeesDepartment)}
          />
        </Box>
        <Box sx={{ width: isMedium ? "100%" : "49%" }}>
          <EmployeePieChart
            name={"Active Employees JobType"}
            data={getCounts(stats?.activeEmployeesJobType)}
            labels={getIds(stats?.activeEmployeesJobType)}
          />
        </Box>
      </Box>
    </>
  );
};

export default EmploymentStats;
